import script from "./ImportTable.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImportTable.component.vue?vue&type=script&lang=ts&setup=true"

import "./ImportTable.component.vue?vue&type=style&index=0&id=3948acfc&lang=css"

const __exports__ = script;

export default __exports__